export const materials_index = ['materials.index']
export const materials_create = ['materials.create']
export const materials_edit = ['materials.edit']

export default [].concat(
    materials_index,
    materials_create,
    materials_edit
)
